import { Controller } from "@hotwired/stimulus";
import { formSubmitWithWaitForJobCompletion } from "../jobCompletion";
import * as Turbo from "@hotwired/turbo";
import { getScoreFunctionPreservingOrderInSearch, selectize } from "../selectizeHelper";

export default class CreateOrEditController extends Controller {
    static targets = ["companySelect", "form", "submitButton"];

    readonly companySelectTarget!: HTMLElement;
    readonly formTarget!: HTMLElement;
    readonly submitButtonTarget!: HTMLElement;

    private _companySelect: JQuery<HTMLElement> | undefined;
    private _form: JQuery<HTMLElement> | undefined;
    private _submitButton: JQuery<HTMLElement> | undefined;
    private _model: IUsersCreateOrEditModel | undefined;

    connect() {
        this._companySelect = $(this.companySelectTarget);
        this._form = $(this.formTarget);
        this._submitButton = $(this.submitButtonTarget);
        this._model = JSON.parse(this.data.get("model")!) as IUsersCreateOrEditModel;

        selectize(this._companySelect, {
            score: getScoreFunctionPreservingOrderInSearch
        });

        formSubmitWithWaitForJobCompletion(
            this._form,
            this._submitButton,
            this._model.getJobUrl,
            () => {
                Turbo.clearCache();
                history.back();
            }
        );
    }
}

interface IUsersCreateOrEditModel {
    getJobUrl: string;
}